import styled from "styled-components";

import * as yup from "yup";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";

import { InputText } from "../../components/form";
import { useMutation } from "@apollo/client";
import { useEffect } from "react";
import { RECOVER_PASSWORD } from "../../services/auth";
import { Button, TextLink } from "../../components/ui";
import { LogoClaims } from "../../assets/icons/Icons";
import { useState } from "react";
const schema = yup.object({
  email: yup
    .string()
    .required("Ingresa un email valido")
    .email("Ingresa un email valido"),
});

const Container = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  align-items: center;
  justify-content: center;
  margin-top: -80px;
  & > div > svg {
    margin-bottom: 50px;
  }
`;

const LoginWrapper = styled.div`
  border-radius: 20px;
  padding: 46px;
  display: flex;
  flex-direction: column;
  gap: 28px;
  width: 100%;
  max-width: 600px;
  box-shadow: 19px 70px 29px rgba(4, 3, 63, 0.01),
    11px 40px 25px rgba(4, 3, 63, 0.03), 5px 18px 18px rgba(4, 3, 63, 0.04),
    1px 4px 10px rgba(4, 3, 63, 0.05), 0px 0px 0px rgba(4, 3, 63, 0.05);
`;

const StyledTitle = styled.h2`
  font-weight: 700;
  font-size: 28px;
  color: #4f5e74;
  text-align: center;
  margin-bottom: 16px;
`;

const StyledSubtitle = styled.p`
  font-weight: 400;
  font-size: 14px;
  color: #3E4451;
  text-align: center;
  margin-bottom: 44px;
`;

const StyledForm = styled.form`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const StyledMessage = styled.p`
    font-weight: 400;
    font-size: 16px;
    color: #218631;
    text-align: center;
    margin-top: 24px;
    ${({ error }) => error && `
    color: #F44336;
  `}
`;
export default function RecoverPassword() {
  const {
    handleSubmit,
    register,
    reset,
    formState: { errors },
  } = useForm({ resolver: yupResolver(schema) });
  const [sendRecoverPassEmail, result] = useMutation(RECOVER_PASSWORD);
  const [recoverStatus, setRecoverStatus ] = useState("");
  const formSubmit = (data) => {
    sendRecoverPassEmail({ variables: { email: data.email } });
  };

  useEffect(() => {
    if (result.data) {
      if (result.data?.forgottenPass?.statusCode === 200) {
        setRecoverStatus("Success");
        reset({
          email: "",
        });
      } else {
        setRecoverStatus("Error");
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [result.data]);

  return (
    <Container>
      <LogoClaims w="240" h="60" />
      <StyledTitle>¿Olvidaste tu contraseña?</StyledTitle>
      <StyledSubtitle>Ingresa tu correo electrónico para restablecer tu contraseña</StyledSubtitle>
      <LoginWrapper>
        <StyledForm onSubmit={handleSubmit(formSubmit)}>
          <InputText
            label="Ingresa tu correo"
            type="email"
            placeholder="Correo electrónico"
            register={{ ...register("email") }}
            errorMessage={errors.email?.message}
          />
          <Button
            text={"Restablecer contraseña"}
            type="submit"
            style={{ alignSelf: "center", marginTop: "10px" }}
          />
        </StyledForm>
        {
          recoverStatus === "Error" ?
            <StyledMessage error={true}>
              El correo no ha podido ser enviado, intente mas tarde.
            </StyledMessage> :
          recoverStatus === "Success" ?
            <>
              <StyledMessage error={false}>
                El correo se ha enviado a la dirección de email proporcionada por favor revise su bandeja / spam.
              </StyledMessage>
            </>
          : null
        }
        <TextLink to="/" text="O regresa para iniciar sesión" />
      </LoginWrapper>
    </Container>
  );
}
